import { SyncVerb } from '../types/Verbs';
import {
	AddCollectionSyncSlice,
	AddCollectionSyncSliceOptions,
	AddSyncSlice,
	AddSyncSliceOptions,
	RemoveCollectionSyncSlice,
	RemoveCollectionSyncSliceOptions,
	RemoveSyncSliceOptions,
	SyncSlice,
	UpdateCollectionSyncSlice,
	UpdateCollectionSyncSliceOptions,
	UpdateSyncSlice,
	UpdateSyncSliceOptions
} from './types';
import { createCollectionSyncRedux, createSyncRedux } from '../redux/lib';

export function createAddSyncSlice<N extends string, T, RQ = void>(
	options: AddSyncSliceOptions<N, T, RQ>
): AddSyncSlice<N, T, RQ> {
	return createSyncRedux({
		...options,
		syncVerb: SyncVerb.Add
	});
}

export function createRemoveSyncSlice<N extends string, T, RQ = void>(
	options: RemoveSyncSliceOptions<N, T, RQ>
): SyncSlice<SyncVerb.Remove, N, T, RQ> {
	return createSyncRedux({
		...options,
		syncVerb: SyncVerb.Remove
	});
}

export function createUpdateSyncSlice<N extends string, T, RQ = void>(
	options: UpdateSyncSliceOptions<N, T, RQ>
): UpdateSyncSlice<N, T, RQ> {
	return createSyncRedux({
		...options,
		syncVerb: SyncVerb.Update
	});
}

export function createAddCollectionSyncSlice<N extends string, T, RQ = void>(
	options: AddCollectionSyncSliceOptions<N, T, RQ>
): AddCollectionSyncSlice<N, T, RQ> {
	return createCollectionSyncRedux({
		...options,
		syncVerb: SyncVerb.Add
	});
}

export function createRemoveCollectionSyncSlice<N extends string, T, RQ = void>(
	options: RemoveCollectionSyncSliceOptions<N, T, RQ>
): RemoveCollectionSyncSlice<N, T, RQ> {
	return createCollectionSyncRedux({
		...options,
		syncVerb: SyncVerb.Remove
	});
}

export function createUpdateCollectionSyncSlice<N extends string, T, RQ = void>(
	options: UpdateCollectionSyncSliceOptions<N, T, RQ>
): UpdateCollectionSyncSlice<N, T, RQ> {
	return createCollectionSyncRedux({
		...options,
		syncVerb: SyncVerb.Update
	});
}
